import React, { useState, useRef, useEffect } from "react";
import { useReactToPrint } from 'react-to-print';
import LoiNhuanApi from "service/BaoCao/LoiNhuanApi";
import InDsChiTietLoiNhuan from "./InDsChiTietLoiNhuan";
import { format, startOfYear, endOfYear } from 'date-fns';
import { pushNotification } from "utils/notifications";

const mapTypeToInt = (typeString) => {
    switch (typeString) {
        case 'tinchap': return 1;
        case 'camdo': return 2;
        case 'tragop': return 3;
        case 'banhang': return 4;
        case 'thungoai': return 5;
        case 'chingoai': return 6;
        case 'chinhanvay': return 7;
        case 'thutrichlap': return 8;
        case 'chitrichlap': return 9;
        default: return 1;
    }
};

const BtnInChiTiet = ({ type, filters, title }) => {
    const componentToPrintRef = useRef();
    const [isFetching, setIsFetching] = useState(false);
    const [printData, setPrintData] = useState(null);
    const [printSums, setPrintSums] = useState({});
    const handlePrint = useReactToPrint({
        content: () => componentToPrintRef.current,
        onAfterPrint: () => {
            setPrintData(null); 
            setPrintSums({});
        },
    });
    useEffect(() => {
        if (printData) {
            handlePrint();
        }
    }, [printData]);

    const handleFetchAndPrint = () => {
        if (isFetching) return;
        setIsFetching(true);
        let dateFrom = filters.dtFrom;
        let dateTo = filters.dtTo;
        if (!dateFrom || !dateTo) {
            dateFrom = startOfYear(new Date());
            dateTo = endOfYear(new Date());
        }
        const reportTypeInt = mapTypeToInt(type);
        const strFrom = format(dateFrom, 'dd/MM/yyyy');
        const strTo = format(dateTo, 'dd/MM/yyyy');
        LoiNhuanApi.getChiTiet(strFrom, strTo, reportTypeInt, -1, 0)
            .then(res => {
                if (res.status === 200 && res.data && res.data.Data && res.data.Data.length > 0) {
                    const { Data, TotalRecords, ...sums } = res.data;
                    setPrintData(Data);
                    setPrintSums(sums);
                } else {
                    pushNotification("Không có dữ liệu để in!", "info");
                }
            })
            .catch(error => {
                console.error("Lỗi in:", error);
                pushNotification("Lỗi khi tải dữ liệu in!", "error");
            })
            .finally(() => {
                setIsFetching(false);
            });
    };

    return (
        <>
            <button
                type="button"
                className="btn"
                onClick={handleFetchAndPrint}
                disabled={isFetching}
                style={{height: '40px', fontSize: '13px',backgroundColor: "#006266", color: "white" }}
            >
                {isFetching ? (
                    <><span className="spinner-border spinner-border-sm"></span> Đang tải...</>
                ) : (
                    <><i className="fas fa-print"></i> In danh sách</>
                )}
            </button>
            <div style={{ display: "none" }}>
                {printData && (
                    <InDsChiTietLoiNhuan
                        ref={componentToPrintRef}
                        listData={printData}
                        totals={printSums}
                        title={title}
                        reportTypeInt={mapTypeToInt(type)}
                    />
                )}
            </div>
        </>
    );
};

export default BtnInChiTiet;